import React from 'react';
import HubspotForm from 'react-hubspot-form'
import RemoteMarkdown from '../../components/RemoteMarkdown';
import './Marketing.css'

const MarketingShow = () => {
    return (
        <div id="flyers" className="marketing-show-wrapper">
                <RemoteMarkdown src="https://markdown-cloud.devon.workers.dev/api/documents/ec5a4f29-5ff0-4d63-a841-ce02857b1a06" /> 

            <div className="h-form">
                <HubspotForm
                    portalId='5425670'
                    formId="645cbd4b-2dcc-4298-ba20-038e5ce88ddd"
                    onReady={(form) => console.log('Form ready!')}
                    loading={<div>Loading...</div>}
                /></div>
        </div>
    )

}

export default MarketingShow